import $ from 'jquery';
import Component from '../models/Component';

export default class ProductImages extends Component {
    constructor(element, context) {
        super(element, context);

        $(document).ready(() => {
            const images = this.element.find('.product_image');
            const activeImage = this.element.find('.active_image');

            // Immagine iniziale
            const firstImage = images.first();
            const firstSrc = firstImage.attr('src');
            activeImage.attr('src', firstSrc);
            firstImage.addClass('active');

            images.on('click', function() {
                const newSrc = $(this).attr('src');
                activeImage.attr('src', newSrc);

                // classe active
                images.removeClass('active');
                $(this).addClass('active');
            });
        });
    }
}
